import { ApiFetch } from '../../../shared/utils/fetch';
import { unwrap, type Enveloped } from '../../../shared/utils/unwrap';
import type { Discrepancy, DiscrepancyFilter } from '../types';

export const reconciliationApi = {
  listDiscrepancies: async (filter?: DiscrepancyFilter): Promise<Discrepancy[]> => {
    const entries = Object.entries(filter ?? {}).filter(([, v]) => v !== undefined && v !== '');
    const qs = entries.length ? '?' + new URLSearchParams(entries.map(([k, v]) => [k, String(v)])).toString() : '';
    const response = await ApiFetch.get<Enveloped<Discrepancy[]>>(`/reconciliation/discrepancies${qs}`);
    return unwrap(response);
  },

  /** Manually run reconciliation for a provider + period (YYYY-MM-DD). Returns the discrepancy count. */
  run: async (provider: string, period: string): Promise<number> => {
    return ApiFetch.post<number>(
      `/reconciliation/run/${encodeURIComponent(provider)}/${encodeURIComponent(period)}`,
    );
  },
};
